'use client'

import { exportLegalDocumentPdf } from '@/lib/legal/exportLegalDocumentPdf'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import { IconButton, Tooltip } from '@mui/material'
import { useState } from 'react'

type Props = {
  title: string
  version: string
  markdown: string
  slug: string
}

export default function LegalDocumentPdfButton({ title, version, markdown, slug }: Props) {
  const [busy, setBusy] = useState(false)

  const handleDownload = async () => {
    if (busy) return
    setBusy(true)
    try {
      await exportLegalDocumentPdf(title, version, markdown, slug)
    } finally {
      setBusy(false)
    }
  }

  return (
    <Tooltip title={busy ? 'PDF hazırlanıyor…' : 'PDF indir'}>
      <span>
        <IconButton
          aria-label="PDF indir"
          onClick={() => void handleDownload()}
          disabled={busy}
          size="small"
          sx={{
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <PictureAsPdfOutlinedIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  )
}
